import React from 'react'
import Paper from '@material-ui/core/Paper'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    background: theme.palette.primary.main,
    borderRadius: 10,
    color: 'white',
    padding: 10,
  },
  dt: {
    color: theme.palette.secondary.main,
  },
  dl: {
    color: theme.palette.secondary.main,
    display: 'flex',
    fontFamily: 'sans-serif',
  },
  dd: {
    color: theme.palette.secondary.main,
    marginLeft: 'auto',
  },
  font: {
    fontSize: 18,
  },
  header: {
    color: 'black',
    fontFamily: 'sans-serif',
    marginBottom: '0.5rem',
    marginLeft: '0.5rem',
  },
}))

export default function TotalData(props) {
  const classes = useStyles()
  const { totalData, totalUp, totalDown } = props

  return (
    <div>
      <h4 className={classes.header}>Total Data</h4>
      <Paper className={classes.root}>
        <dl className={classes.dl}>
          <dt className={classes.dt}>Total Uploaded:</dt>
          <dd className={classes.dd}>{totalUp || 'N/A'}</dd>
        </dl>

        <dl className={classes.dl}>
          <dt className={classes.dt}>Total Downloaded:</dt>
          <dd className={classes.dd}>{totalDown || 'N/A'}</dd>
        </dl>

        <dl className={classes.dl}>
          <dt className={classes.dt}>Total Data Usage:</dt>
          <dd className={classes.dd}>{totalData || 'N/A'}</dd>
        </dl>
      </Paper>
    </div>
  )
}

TotalData.propTypes = {
  totalData: PropTypes.string,
  totalUp: PropTypes.string,
  totalDown: PropTypes.string,
}

TotalData.defaultProps = {
  totalData: 'N/A',
  totalUp: 'N/A',
  totalDown: 'N/A',
}
